'use client';

import { BrandRankingType } from '@/types';
import styles from './bestCard.module.scss';
import { Button, Drawer, Input, message, Modal } from 'antd';
import Image from 'next/image';
import { GoArrowDown, GoArrowUp } from 'react-icons/go';
import { COLORS } from '@/utilities';
import { useContext, useState } from 'react';
import { GlobalContext } from '@/context';
import { TbArrowNarrowDown, TbArrowNarrowUp, TbChevronLeft } from 'react-icons/tb';
import { RestAPI, useAsyncClick, useBP } from '@/scripts';
import { API } from '@/data';
import { AuthModalComp } from '@/components';
function __RankCardComp({
  data,
  isActive
}: {
  data: BrandRankingType<'list'> | BrandRankingType<'detail'>;
  isActive: boolean;
}) {
  const myReview = data.my_reviews?.at(0);
  const [vote, setVote] = useState<'up' | 'down' | undefined>(myReview ? myReview.like ? 'up' : 'down' : undefined);
  const [likes, setLikes] = useState(data.likes_count);
  const [disLikes, setDisLikes] = useState(data.dislike_count);
  const {
    langText,
    profile
  } = useContext(GlobalContext);
  const lang = langText.bests;
  const image = data.brand.main_image;
  const [selectedVote, setSelected] = useState<'up' | 'down'>();
  const [review, setReview] = useState(myReview?.comment ?? '');
  const [login, setLogin] = useState<'up' | 'down'>();
  const [messageApi, contextHolder] = message.useMessage();
  const bp = useBP();
  const isMobile = bp?.MD_LTE;
  const onSubmit = useAsyncClick(() => {
    if (vote === 'up') {
      setLikes(likes - 1);
    } else if (vote === 'down') {
      setDisLikes(disLikes - 1);
    }
    setVote(undefined);
    return RestAPI.post(API.ranking.add, {
      brand_category: data.id,
      brand: data.brand.id,
      like: selectedVote === 'up',
      comment: review.length ? review : undefined
    }).then(() => {
      if (selectedVote === 'up') {
        setLikes(likes + 1);
        setVote('up');
      } else if (selectedVote === 'down') {
        setDisLikes(disLikes + 1);
        setVote('down');
      }
      messageApi.success(lang.voteSuccess);
      setSelected(undefined);
    }).catch(() => {
      messageApi.error(langText.general.error);
    });
  });
  function voteHandler(e: any, v: 'up' | 'down') {
    e?.preventDefault();
    e?.stopPropagation();
    if (!profile) {
      setLogin(v);
    } else setSelected(v);
  }
  const Content = <>
            <p className="mb-2">{lang.reviewDesc}</p>
            <Input.TextArea placeholder={lang.review} value={review} onChange={e => setReview(e.target.value)} />
            <div className={styles['review-action']}>
                <Button type="text" onClick={() => {
        setSelected(undefined);
      }}>
                    {langText.general.cancel}
                </Button>
                <Button loading={onSubmit.loading} onClick={onSubmit.onClick} className={`w-100`}>
                    {langText.general.confirm}
                </Button>
            </div>
        </>;
  return <>
            {contextHolder}
            <AuthModalComp open={login !== undefined} onClose={() => {
      setLogin(undefined);
    }} onSuccess={() => {
      setSelected(login);
      setLogin(undefined);
    }} data-sentry-element="AuthModalComp" data-sentry-source-file="bestCard.index.tsx" />
            {isMobile ? <Drawer open={selectedVote !== undefined} placement="bottom" height={'auto'} className="pt-4 pb-2 ph-2" closeIcon={null}>
                    {Content}
                </Drawer> : <Modal open={selectedVote !== undefined} closeIcon={null} footer={null}>
                    {Content}
                </Modal>}
            <div className={`${styles['best-card']} ${isActive ? styles['active'] : ''}`}>
                <div className="center-content-y flex-between">
                    <div className={`${styles['right-section']} center-content-y`}>
                        <div className={`${styles['index']} center-content d-pre-md-none`}>
                            <p>{data.rank}</p>
                        </div>
                        <div className={`${styles['image']}`}>
                            {image ? <Image src={image.file} width={50} height={50} alt={data.brand.title} /> : null}
                        </div>
                        <div className={`${styles['title']} center-content mh-1`}>
                            <p className="t-p1 t-500 t-dark1 center-content">{data.brand.title}</p>
                        </div>
                    </div>
                    <div className={`${styles['left-section']} center-content d-pre-md-none`}>
                        <div onClick={e => voteHandler(e, 'down')} className={`${styles['down']} ${vote === 'down' ? styles['down-active'] : ''} center-content`}>
                            <GoArrowDown size={20} color={vote === 'down' ? '#fff' : COLORS.red} data-sentry-element="GoArrowDown" data-sentry-source-file="bestCard.index.tsx" />
                            <p className="t-red t-500">{disLikes}</p>{' '}
                        </div>
                        <div onClick={e => voteHandler(e, 'up')} className={`${styles['up']} ${vote === 'up' ? styles['up-active'] : ''} center-content`}>
                            <p className="t-primary t-500">{likes}</p>{' '}
                            <GoArrowUp size={20} color={vote === 'up' ? '#fff' : COLORS.primary} data-sentry-element="GoArrowUp" data-sentry-source-file="bestCard.index.tsx" />
                        </div>
                    </div>
                </div>
                <div className={`${styles['mobile-actions']} d-md-none mt-2  center-content-y`}>
                    <div className={styles['actions']}>
                        <button onClick={e => voteHandler(e, 'down')} className={vote === 'down' ? styles['active'] : ''}>
                            <TbArrowNarrowDown size={20} data-sentry-element="TbArrowNarrowDown" data-sentry-source-file="bestCard.index.tsx" />
                            <span>{disLikes}</span>
                        </button>
                        <p>{data.is_ad ? 'Ad' : lang.rank(data.rank ?? 0)}</p>
                        <button onClick={e => voteHandler(e, 'up')} className={vote === 'up' ? styles['active'] : ''}>
                            <span>{likes}</span>
                            <TbArrowNarrowUp size={20} data-sentry-element="TbArrowNarrowUp" data-sentry-source-file="bestCard.index.tsx" />
                        </button>
                    </div>
                    <button>
                        <span>{lang.aboutBrand}</span>
                        <TbChevronLeft data-sentry-element="TbChevronLeft" data-sentry-source-file="bestCard.index.tsx" />
                    </button>
                </div>
            </div>
        </>;
}
export default __RankCardComp;